import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { AuthActions, RootState } from '../Store'

export const SigninCallback = ({ history }: RouteComponentProps) => {
  const dispatch = useDispatch()
  const validUser = Boolean(useSelector((state: RootState) => state.Auth.user))
  const goTo = history.push

  React.useEffect(() => {
    dispatch(AuthActions.signinRedirectCallbackAction())
  }, [dispatch])

  React.useEffect(() => {
    if (validUser) goTo('/')
  }, [validUser, goTo])

  return <>Logando</>
}
